/* eslint-disable no-console */
import _ from 'underscore';
import { updateSingleProductDealerShareModal } from './modules/dealer-contact/single-product-dealer-share-modal';
import { addPhotosModal, updatePhotosModal } from './modules/product-details/photos-modal';
import { initProductFavoriteButtons, updatePageFavoritesProperties, updateProductFavoriteButtons } from './modules/product-details/product-saving';
import { addColorSwap } from './modules/product-details/color-swap';
import ProductOptions from './modules/product-details/product-options';
import { addSwatchesModal, updateSwatchesModal } from './modules/product-details/swatches-modal';
import { updateAssetUrlDimensions } from './modules/widen-utils';
import Breakpoint from './modules/breakpoint';
import swatchList from './modules/swatch-list';

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

const thumbnailTemplate =
  `<button class="product-image-thumb photos-modal-btn" aria-label="View larger version of this photo in the gallery modal">
    <div class="site-image-wrapper">
      <img class="site-image lazy" src="{{ url }}" alt="{{ alt }}" />
    </div>
  </button>`;

const thumbnailTemplateVals = _.template(thumbnailTemplate);

const productDetails = (options) => {
  // console.log('\n\n\n*************************\n\nproduct-detail.js ver: 1.0.25 \n\n*************************\n\n\n');
  const {
    productCode,
    productName,
  } = options;

  const selectedOption = {
    colorCode: '',
    colorName: '',
    productCode,
    productName,
    photos: {},
  };

  const getSelectedColorCode = () => (
    selectedOption.colorCode
  );

  const setSelectedColorCode = (value) => {
    selectedOption.colorCode = value;
  };

  const getSelectedColorName = () => (
    selectedOption.colorName
  );

  const setSelectedColorName = (value) => {
    selectedOption.colorName = value;
  };

  const getSelectedColorPhotos = () => (
    selectedOption.photos
  );

  const setSelectedColorPhotos = (value) => {
    selectedOption.photos = value;
  };

  const updateProductHeroPhotoSet = (photos) => {
    const {
      primaryImage,
      additionalImages,
    } = photos;
    // Update primary product image
    const wrapperDiv = document.querySelector('.product-detail-hero');
    const primaryProductImg = wrapperDiv.querySelector('.primary-product-img');
    primaryProductImg.src = primaryImage.url;
    primaryProductImg.setAttribute('alt', primaryImage.alt);
    const caption = wrapperDiv.querySelector('.caption');
    caption.textContent = primaryImage.caption;
    // Clear out exsiting thumbnails
    const thumbWrapperDiv = wrapperDiv.querySelector('.product-image-thumb-content');
    thumbWrapperDiv.innerHTML = '';
    // Add new
    additionalImages.forEach((thumb, index) => {
      if (index <= 7) {
        // Resize thumb image
        thumb.url = updateAssetUrlDimensions({
          src: thumb.url,
          width: 80,
          height: 80,
        });
        const div = document.createElement('div');
        const compiled = thumbnailTemplateVals(thumb);
        div.innerHTML = compiled;
        thumbWrapperDiv.appendChild(div.firstChild);
      }
    });
  };

  const onSelectedColorPhotosLoaded = () => {
    const photos = getSelectedColorPhotos();
    // Is there a primary image? If not don't run any updates
    if (photos.primaryImage === null) {
      return;
    }
    if (photos.primaryImage.url === '') {
      return;
    }
    const selectedColorCode = getSelectedColorCode();
    const selectedColorName = getSelectedColorName();
    updateSwatchesModal({
      photos,
      selectedColorCode,
      selectedColorName,
    });
    updateSingleProductDealerShareModal({
      photos,
      selectedColorCode,
      selectedColorName,
    });
    updatePhotosModal({
      photos,
      selectedColorCode,
      selectedColorName,
    });
    updateProductHeroPhotoSet(photos);
    updatePageFavoritesProperties({
      code: getSelectedColorCode(),
      colorName: getSelectedColorName(),
      photo: photos.primaryImage.url,
      productName,
    });
    updateProductFavoriteButtons({
      code: getSelectedColorCode(),
    });
  };

  const loadSelectedColorPhotos = () => {
    const { getColorVariantImagesUrl } = window;
    const requestUrl = `${getColorVariantImagesUrl}${getSelectedColorCode()}/images`;
    const request = new XMLHttpRequest();
    request.open('GET', requestUrl, true);
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        const responseData = JSON.parse(request.responseText);
        if (responseData.images) {
          setSelectedColorPhotos(responseData.images);
        }
        onSelectedColorPhotosLoaded();
      }
    };
    request.onerror = (data) => {
      console.log(data);
    };
    request.send();
  };

  const onUpdateSelectedColor = (btn) => {
    const colorCode = btn.getAttribute('data-colorvariantcode');
    const colorName = btn.getAttribute('data-colorname');
    setSelectedColorCode(colorCode);
    setSelectedColorName(colorName);
    loadSelectedColorPhotos();
  };

  const initSwatchList = () => {
    const map = {};
    map[Breakpoint.XS.name] = 6;
    map[Breakpoint.SM.name] = 10;
    map[Breakpoint.MD.name] = 6;
    map[Breakpoint.LG.name] = 8;
    map[Breakpoint.XL.name] = 10;
    map[Breakpoint.XXL.name] = 10;
    swatchList('.product-swatch-list', map);
  };

  const init = () => {
    // Photo modal
    addPhotosModal();
    // Swatches modal
    addSwatchesModal({
      onUpdate: onUpdateSelectedColor,
    });
    // Resizing product options
    ProductOptions();
    // Color Swap for detail page (color swap for swatches modal is set separately)
    addColorSwap({
      btnSelector: '.swatch-image',
      groupSelector: '.product-swatch-list',
      runInit: true,
      onUpdate: onUpdateSelectedColor,
    });
    updatePageFavoritesProperties({
      code: getSelectedColorCode(),
      colorName: getSelectedColorName(),
      photo: document.querySelector('.primary-product-img').src,
      productName,
    });
    initProductFavoriteButtons();
    initSwatchList();
  };
  init();
};
window.ProductDetailUtils = productDetails;

export default productDetails;
/* eslint-enable no-console */
